/**
 * @generated SignedSource<<953bb9699fa223bacc36b271f94c7c31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SchoolExamSourceInnerPdfUploadInput = {
  innerPdf: Upload;
  schoolExamSource: string;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type SchoolExamSourceInnerPdfUploadDialog_schoolExamSourceInnerPdfUploadMutation$variables = {
  input: SchoolExamSourceInnerPdfUploadInput;
};
export type SchoolExamSourceInnerPdfUploadDialog_schoolExamSourceInnerPdfUploadMutation$data = {
  readonly schoolExamSourceInnerPdfUpload: {
    readonly id: string;
    readonly innerPdf: {
      readonly id: string;
      readonly key: string;
      readonly objectUrl: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource">;
  };
};
export type SchoolExamSourceInnerPdfUploadDialog_schoolExamSourceInnerPdfUploadMutation = {
  response: SchoolExamSourceInnerPdfUploadDialog_schoolExamSourceInnerPdfUploadMutation$data;
  variables: SchoolExamSourceInnerPdfUploadDialog_schoolExamSourceInnerPdfUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "innerPdf",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "objectUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "created": "DESC"
    }
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SchoolExamSourceInnerPdfUploadDialog_schoolExamSourceInnerPdfUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SchoolExamSource",
        "kind": "LinkedField",
        "name": "schoolExamSourceInnerPdfUpload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SchoolExamSourceInnerPdfUploadDialog_schoolExamSourceInnerPdfUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SchoolExamSource",
        "kind": "LinkedField",
        "name": "schoolExamSourceInnerPdfUpload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "SchoolExamSourceHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SchoolExamSourceHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SchoolExamSourceHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "picture",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDeleted",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "scrapImages",
                                "plural": true,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "SchoolExamSourcePublishDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "innerPdf",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "SchoolExamSourceUploadDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10,order:{\"created\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "filters": [
              "filters",
              "order"
            ],
            "handle": "connection",
            "key": "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4e268d98e0b44c810b9821c772194bc4",
    "id": null,
    "metadata": {},
    "name": "SchoolExamSourceInnerPdfUploadDialog_schoolExamSourceInnerPdfUploadMutation",
    "operationKind": "mutation",
    "text": "mutation SchoolExamSourceInnerPdfUploadDialog_schoolExamSourceInnerPdfUploadMutation(\n  $input: SchoolExamSourceInnerPdfUploadInput!\n) {\n  schoolExamSourceInnerPdfUpload(input: $input) {\n    id\n    innerPdf {\n      id\n      key\n      objectUrl\n    }\n    ...SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment SchoolExamSourceHistoryDialog_SchoolExamSourceHistory on SchoolExamSourceHistory {\n  id\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...SchoolExamSourcePublishDifferenceCounterLabel_difference\n    ...SchoolExamSourcePublishDifferenceItemList_difference\n    ...SchoolExamSourceUploadDifferenceCounterLabel_difference\n    ...SchoolExamSourceUploadDifferenceItemList_difference\n  }\n}\n\nfragment SchoolExamSourceHistoryTimelineItem_schoolExamSourceHistory on SchoolExamSourceHistory {\n  created\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  type\n}\n\nfragment SchoolExamSourcePublishDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourcePublishDifference {\n    scrapImages {\n      __typename\n    }\n  }\n}\n\nfragment SchoolExamSourcePublishDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourcePublishDifference {\n    scrapImages {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource on SchoolExamSource {\n  histories(order: {created: DESC}, first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...SchoolExamSourceHistoryDialog_SchoolExamSourceHistory\n        ...SchoolExamSourceHistoryTimelineItem_schoolExamSourceHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment SchoolExamSourceUploadDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourceUploadDifference {\n    innerPdf {\n      __typename\n    }\n  }\n}\n\nfragment SchoolExamSourceUploadDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourceUploadDifference {\n    innerPdf {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "0fef08d136e67477028dbbf43fd853bf";

export default node;
